import { config } from "@fortawesome/fontawesome-svg-core";
//#region src/fontawesome/index.ts
config.autoAddCss = false;
//#endregion
export {};
